module.exports = __webpack_public_path__ + "static/img/report_bg4.870b29b6.png";